/**
 * Show scripts.
 *
 * Handles interactive functinoality for showcase components
 */

/** Dependencies -------------------------------------------- */

// External

// Design system

/** The beef ------------------------------------------------ */

/**
 * showcase mixin.
 */
export let mixin = ({ node = null, config = {} } = {}) => {
   let state = {
      node,
      config,
      container: node.querySelector(`[data-js="container"]`),
      tabs: node.querySelectorAll(`[data-target]`),
      slides: node.querySelectorAll(`[data-tab-id]`),
   };

   let module = {
      setContainerHeight() {
         if (!state.slides.length) return;

         let heights = [...state.slides].map((slide) => {
            return slide.children[0].offsetHeight;
         });

         let tallest = Math.max(...heights);

         state.container.style.height = `${tallest}px`;
      },

      toggleActiveSlide(activeTab) {
         let selectedId = activeTab.dataset.target;
         let selectedSlide = node.querySelector(`[data-tab-id="${selectedId}"]`);

         [...state.slides].map((slide) => {
            slide.classList.remove('js-is-active');
         });

         selectedSlide.classList.add('js-is-active');
      },

      toggleActiveTab(activeTab) {
         [...state.tabs].map((tab) => {
            tab.classList.remove('js-is-active');
         });
         activeTab.classList.add('js-is-active');
      },

      onTabClick(e) {
         let clicked = e.currentTarget;
         if (clicked.classList.contains('js-is-active')) return;

         this.toggleActiveTab(clicked);
         this.toggleActiveSlide(clicked);
      },

      setEventBindings() {
         if (!state.tabs.length) return;

         [...state.tabs].map((tab) => {
            tab.addEventListener('click', this.onTabClick.bind(this));
         });

         window.addEventListener('resize', this.setContainerHeight.bind(this));
      },

      init() {
         this.setEventBindings();
         this.setContainerHeight();
      },
   };

   return module.init();
};

/**
 * Filter module.
 * Provides an interface to apply filter functionality to all elements matching a selector.
 */
export default {
   init({ selector, config = {} }) {
      let selected = document.querySelectorAll(selector);

      if (!selected.length) return;

      return Array.from(selected).map((node, index) => mixin({ node, config }));
   },
};
